import { render } from "./EditMonitaryNoteView.vue?vue&type=template&id=87a6a9e8&scoped=true&ts=true"
import script from "./EditMonitaryNoteView.vue?vue&type=script&lang=ts"
export * from "./EditMonitaryNoteView.vue?vue&type=script&lang=ts"

import "./EditMonitaryNoteView.vue?vue&type=style&index=0&id=87a6a9e8&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a6a9e8"]])

export default __exports__